import React from 'react';
import { Activity, CheckSquare, StickyNote, Home, UtensilsCrossed, Calendar, Vote, MessageSquare, FileText, Dumbbell, UserRound, DollarSign, ShoppingCart, Radio, UsersRound, Shield, PartyPopper, Compass, Smile } from 'lucide-react';

type IconComponent = React.ComponentType<{ size?: number | string; color?: string }>;

const idToIcon: Record<string, IconComponent> = {
  '@yada/app-habits': Activity,
  '@yada/app-todo': CheckSquare,
  '@yada/app-home': Home,
  '@yada/app-meal-planner': UtensilsCrossed,
  '@yada/app-calendar': Calendar,
  '@yada/app-events': PartyPopper,
  '@yada/app-trips': Compass,
  '@yada/app-community-votes': Vote,
  '@yada/app-chat': MessageSquare,
  '@yada/app-docs': FileText,
  '@yada/app-training': Dumbbell,
  '@yada/app-contacts': UserRound,
  '@yada/app-finance': DollarSign,
  '@yada/app-shopping-list': ShoppingCart,
  '@yada/app-groups': UsersRound,
  '@yada/app-content-distribution': Radio,
  '@yada/app-admin': Shield,
  '@yada/app-emoji': Smile,
};

export function getAppIcon(appId: string): IconComponent {
  return idToIcon[appId] || StickyNote;
}


